export const TIMESHEET_SLOT_TABS = {
  shifts: "shifts",
  trainings: "trainings",
};

export const TIMESHEET_URL_PARAMS = {
  applicant: "applicant",
};

export const TIMESHEET_EVENT_TAB = "timesheet";

export const TIMESHEET_APPLICANT_STATUSES = {
  approved: "approved",
  removed: "removed",
  cancelled: "cancelled",
};

export const TIMESHEET_CHECKOUT_STATUSES = {
  self: "self",
  auto: "auto",
  pending: "pending",
};

export const TIMESHEET_EMPTY_STATE_VARIANTS = {
  event: "event",
  shifts: "shifts",
  trainings: "trainings",
  filtered: "filtered",
};
